<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="templateName" id="templateName" type="text" pInputText>
            <label for="templateName">Template Name</label>
            @for (validation of validationMessages.templateName; track validation) {
              <span>
                @if (form1.get('templateName').hasError(validation.type) && (form1.get('templateName').dirty || form1.get('templateName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="locationId" id="locationId" type="number" pInputText>
            <label for="locationId">Location ID</label>
            @for (validation of validationMessages.locationId; track validation) {
              <span>
                @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrDistrict" id="adrDistrict" type="text" pInputText>
            <label for="adrDistrict">Adr District</label>
            @for (validation of validationMessages.adrDistrict; track validation) {
              <span>
                @if (form1.get('adrDistrict').hasError(validation.type) && (form1.get('adrDistrict').dirty || form1.get('adrDistrict').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCity" id="adrCity" type="text" pInputText>
            <label for="adrCity">Adr City</label>
            @for (validation of validationMessages.adrCity; track validation) {
              <span>
                @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrRegion" id="adrRegion" type="text" pInputText>
            <label for="adrRegion">Adr Region</label>
            @for (validation of validationMessages.adrRegion; track validation) {
              <span>
                @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty || form1.get('adrRegion').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="developmentId" id="developmentId" type="number" pInputText>
            <label for="developmentId">Development ID</label>
            @for (validation of validationMessages.developmentId; track validation) {
              <span>
                @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="bedrooms" id="bedrooms" type="number" pInputText>
            <label for="bedrooms">Bedrooms</label>
            @for (validation of validationMessages.bedrooms; track validation) {
              <span>
                @if (form1.get('bedrooms').hasError(validation.type) && (form1.get('bedrooms').dirty || form1.get('bedrooms').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (propertyFeatureTemplateId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete PropertyFeatureTemplate</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!propertyFeatureTemplateId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add PropertyFeatureTemplate</button>
              }

              @if (propertyFeatureTemplateId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update PropertyFeatureTemplate</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>